const styles = {
  mainBtn: "outlined",
  mainBtnColor: "secondary",
  inputVariant: "outlined",
}

export default styles
